//====================================================
//  Function: Shoptet events
//====================================================

function baseEvents() {
	hideFlagSaleInSaleCategory();
  document.addEventListener("ShoptetDOMContentLoaded", function () {
    partsRepositionProducts();
    addPaginationScroll();
    repositionFilterSections();
    hideFlagSaleInSaleCategory();
    initYotpoCategoryStars();
    yotpoWidgetsContainer.initWidgets();
  });

  document.addEventListener("ShoptetDOMCartContentLoaded", function () {
    componentsCheckout();
    giftPlugin();
    initYotpoCategoryStars();
  });

  document.addEventListener("ShoptetDOMAdvancedOrderLoaded", function () {
    //TODO - new style notification - not finished and not contains 100% use cases
    //partsRepositionProducts();
    //partsRepositionAdvancedOrder();
    upsellGrateCartUpdate();
    customMattressNotice();
  });

  document.addEventListener("shoptet.modal.open", function () {
    $("#colorbox").removeClass("advanced-order-modal");
  });

  document.addEventListener("ShoptetDOMPageContentLoaded", function () {
    repositionFilterSections();
    addPaginationScroll();
    freeDeliveryInCategory();
    dimensionFlagInCategory();
    if($('#products').length) {
      calculateDiscountListing();
      dropdownProductSorting();
      initYotpoCategoryStars();
    }
    if ($('.category-perex').length) {
      topDescriptionShowLessMoreText();
    }
  });

  document.addEventListener("ShoptetPageFilterValueChange", function () {
    isFilterChanged = true;
  });

  document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function () {
    if($('#products').length) {
      calculateDiscountListing();
    }
  });

  document.addEventListener('ShoptetVariantAvailable', function () {
    addMOCLabel();
  });

  document.addEventListener('ShoptetSplitVariantParameterChange', function () {
    addMOCLabel();
  });
}
